import useApi from '../../../hooks/use-api'
import useCacheKeys from '../../../hooks/use-cache-keys'
import { useInfiniteQuery } from 'react-query'
import { flatten } from 'lodash'

const useDiscussionParticipations = ({
    discussionId,
    //offset = 0,
    limit = 20
}= {}) => {
    const cacheKeys = useCacheKeys()
    const { api, url, endpoints, time } = useApi()

    const {
        data,
        isFetching,
        isFetchingMore,
        fetchMore,
        canFetchMore
    } = useInfiniteQuery(
        ['participations', discussionId],
        (key, key2, offset = 0) =>
            api.get(url(endpoints.discussionParticipations, { discussionId }, { offset, limit })),
        {
            getFetchMore: (lastGroup) => {
                const canGetMore = lastGroup.offset + limit < lastGroup.total
                return canGetMore ? lastGroup.offset + limit : false
            },
            staleTime: time.MINUTE,
            refetchInterval: time.MINUTE,
            refetchIntervalInBackground: true,
            enabled: Boolean(discussionId)
        }
    )
    const pages = (data || []).map(page => page.items || [])
    const participations = flatten(pages)

    return {
        isLoading: isFetching || isFetchingMore,
        fetchMore,
        canFetchMore,
        participations,
        pages
    }
}

export default useDiscussionParticipations
